import React, { Component } from 'react';
import styled from 'styled-components';
import * as Connection from './../libs/connections';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';

import Preloader from './../components/global/Preloader';
import SectionImageText from './../components/SectionImageText';
import HeroBannerSmall from '../components/HeroBannerSmall';
import SectionAuthors from '../components/SectionAuthors';
import SectionContact from '../components/SectionContact';
import MotoconciergeSingle from './../components/MotoconciergeSingle';
import backgroundText from '../assets/backgrounds/background-text.jpg';
import heroBackgroundLong from '../assets/backgrounds/hero-long.jpg';

const PageMotoconcierge = styled.div`
    .moto-wrapper {
        margin: 180px auto;
        max-width: 1550px;

        @media (max-width: 767.98px) {
            margin: 100px auto;
        }
    }
    .first-elements {
        margin: 200px 0 250px;
    }
`;

export default class Motoconcierge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            error: false,
            elements: []
        };
    }

    async componentDidMount() {
        try {
            const response = await Connection.getSinglePage('motoconcierge');
            this.setState({
                loading: false,
                elements: response.acf.elements
            });
        } catch (err) {
            this.setState({
                error: true
            });
        }

        $(document).ready(function() {
            window.onscroll = function(event) {
                const offset = window.pageYOffset;
                const wheight = window.innerHeight;
                const html = document.documentElement;
                const docheight = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    html.clientHeight,
                    html.scrollHeight,
                    html.offsetHeight
                );
                const progress = (
                    (offset / (docheight - wheight)) *
                    100
                ).toPrecision(4);

                $('.page__about-us #fillshape').attr('y', progress + '%');
            };
        });
    }

    render() {
        // const params = [
        //   {
        //     wrapperClasses: "container version-1",
        //     paddingTop: 230,
        //     paddingBottom: 380
        //   },
        //   {
        //     wrapperClasses: "container container-small version-2",
        //     paddingTop: 250,
        //     paddingBottom: 300
        //   },
        //   {
        //     wrapperClasses: "container container-small version-3 text-center",
        //     paddingTop: 490,
        //     paddingBottom: 430
        //   }
        // ];

        if (!this.state.error) {
            return (
                <PageMotoconcierge>
                    <HeroBannerSmall
                        fromTop
                        centerForce={true}
                        backgroundImage={heroBackgroundLong}
                        headerText={'Motoconcierge'}
                    />
                    <Preloader global loading={this.state.loading} />
                    <div>
                        <div className="moto-wrapper">
                            {this.state.elements.map((item, idx) => {
                                return (
                                    <>
                                        <MotoconciergeSingle
                                            key={`motosingle-${idx}`}
                                            idx={idx}
                                            item={item}
                                            first={idx === 0}
                                            odd={idx % 2 === 0}
                                        />
                                        {idx === 0 && (
                                            <SectionImageText
                                                key={`sec-image-${idx}`}
                                                wrapperClasses={`col-12 two-line-second text-center`}
                                                text={`POZNAJ NOWE`}
                                                secLine={`PODEJŚCIE DO`}
                                                thirdLine={`WYNAJMU Z V1RAGE`}
                                                backgroundImage={backgroundText}
                                                paddingTop={100}
                                                paddingBottom={220}
                                            />
                                        )}
                                    </>
                                );
                            })}
                        </div>

                        <SectionImageText
                            // wrapperClasses={`col-12 two-line`}
                            wrapperClasses={`col-12`}
                            // wrapperClasses={`container container-small`}
                            text={`All ready to ride`}
                            // secLine={`V1RAGE`}
                            backgroundImage={backgroundText}
                            paddingTop={300}
                            paddingBottom={250}
                            motoconcierge
                        />
                        <SectionAuthors />
                        <SectionContact
                            version={1}
                            pageType="send-form-about-us"
                        />
                    </div>
                </PageMotoconcierge>
            );
        } else {
            return <Redirect to="/error" />;
        }
    }
}
